export const createReducer = (initialState = {}, handlers = {}) => {
  return (state = initialState, action = {}) => {
    if (handlers[action.type]) {
      return { ...state, ...handlers[action.type](state, action) };
    }
    return state;
  };
};
